import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 公共路由
export const constantRoutes = [
{
  path: "/",
  name: "Home",
  meta: {
    title: "首页",
    routerClass: "rc-index"
  },
  component: () => import('../views/index.vue'),
},
{
  path: "/report/list",
  name: "report_list",
  meta: {
    title: "发现报告",
    routerClass: "rc-type1",
    needLogin: true
  },
  component: () => import('../views/report/list.vue'),
},
{
  path: "/report/read",
  name: "report_read",
  meta: {
    title: "在线阅读",
    needLogin: true
  },
  component: () => import('../views/report/read.vue'),
},
{
  path: "/qingbao/list",
  name: "qingbao_list",
  meta: {
    title: "数据情报",
    routerClass: "rc-type2",
    needLogin: true
  },
  component: () => import('../views/qingbao/list.vue'),
},
{
  path: "/policy/list",
  name: "policy_list",
  meta: {
    title: "行业洞察",
    routerClass: "rc-type1",
    needLogin: true
  },
  component: () => import('../views/policy/list.vue'),
},
{
  path: "/policy/detail",
  name: "policy_detail",
  meta: {
    title: "行业洞察详情页",
    needLogin: true
  },
  component: () => import('../views/policy/detail.vue'),
},
{
  path: "/news/list",
  name: "news_list",
  meta: {
    title: "行业洞察",
    routerClass: "rc-type1",
    needLogin: true
  },
  component: () => import('../views/news/list.vue'),
},
{
  path: "/news/detail",
  name: "news_detail",
  meta: {
    title: "行业洞察详情页",
    needLogin: true
  },
  component: () => import('../views/news/detail.vue'),
},
{
  path: "/login",
  name: "login",
  meta: {
    title: "登录",
    routerClass: "rc-type0"
  },
  // component: () => import('../views/login.vue'),
  component: () => import('../views/sso_login.vue'),
},
// {
//   path: "/register",
//   name: "register",
//   meta: {
//     title: "注册",
//     routerClass: "rc-type0"
//   },
//   component: () => import('../views/register.vue'),
// },
// {
//   path: "/forgot_password",
//   name: "forgot_password",
//   meta: {
//     title: "忘记密码",
//     routerClass: "rc-type0"
//   },
//   component: () => import('../views/forgot_password.vue'),
// },
{
  path: "/user/collect",
  name: "user_collect",
  meta: {
    title: "我的收藏",
    needLogin: true
  },
  component: () => import('../views/user/collect.vue'),
},
{
  path: "/user/jifen",
  name: "user_jifen",
  meta: {
    title: "我的积分",
    needLogin: true
  },
  component: () => import('../views/user/jifen.vue'),
},
{
  path: "/user/download",
  name: "user_download",
  meta: {
    title: "我的下载",
    needLogin: true
  },
  component: () => import('../views/user/download.vue'),
},
{
  path: "/user/vip",
  name: "user_vip",
  meta: {
    title: "我的VIP",
    needLogin: true
  },
  component: () => import('../views/user/vip.vue'),
},
{
  path: "/user/wechatpay",
  name: "user_wechatpay",
  meta: {
    title: "微信支付",
    needLogin: true
  },
  component: () => import('../views/user/wechatpay.vue'),
},
{
  path: "/pay_success",
  name: "pay_success",
  meta: {
    title: "支付成功",
    needLogin: true
  },
  component: () => import('../views/user/pay_success.vue'),
},
{
  path: "/user/order",
  name: "user_order",
  meta: {
    title: "我的订单",
    needLogin: true
  },
  component: () => import('../views/user/order.vue'),
},
{
  path: "/user/upload",
  name: "user_upload",
  meta: {
    title: "我的上传",
    needLogin: true
  },
  component: () => import('../views/user/upload.vue'),
},
// {
//   path: "/user/info",
//   name: "user_info",
//   meta: {
//     title: "个人资料",
//     needLogin: true
//   },
//   component: () => import('../views/user/info.vue'),
// },
// {
//   path: "/user/password",
//   name: "change_password",
//   meta: {
//     title: "修改密码",
//     needLogin: true
//   },
//   component: () => import('../views/user/change_password.vue'),
// },
// {
//   path: "/user/email",
//   name: "change_email",
//   meta: {
//     title: "我的邮箱",
//     needLogin: true
//   },
//   component: () => import('../views/user/change_email.vue'),
// },
{
  path: "/company/detail",
  name: "company_detail",
  meta: {
    title: "企业详情",
    needLogin: true
  },
  component: () => import('../views/company/detail.vue'),
},
{
  path: "/industry/detail",
  name: "industry_detail",
  meta: {
    title: "产业详情",
    needLogin: true
  },
  component: () => import('../views/industry/detail.vue'),
},
{
  path: "/school/detail",
  name: "school_detail",
  meta: {
    title: "高校详情",
    needLogin: true
  },
  component: () => import('../views/school/detail.vue'),
},
{
  path: "/region/detail",
  name: "region_detail",
  meta: {
    title: "区域详情",
    needLogin: true
  },
  component: () => import('../views/region/detail.vue'),
},


{
  path: "/tongji/index",
  name: "tongji_index",
  meta: {
    title: "统计数据",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/index.vue'),
},

// {
//   path: "/console_old/index",
//   name: "console_old_index",
//   meta: {
//     title: "我的工作台-新建报告",
//     routerClass: "rc-console",
//     needLogin: true
//   },
//   component: () => import('../views/console/index.vue'),
// },
// {
//   path: "/console_old/list",
//   name: "console_old_list",
//   meta: {
//     title: "我的工作台-我的报告",
//     routerClass: "rc-console",
//     needLogin: true
//   },
//   component: () => import('../views/console/list.vue'),
// },
// {
//   path: "/mark",
//   name: "mark",
//   meta: {
//     title: "图片数据质检",
//   },
//   component: () => import('../views/mark.vue'),
// },
// {
//   path: "/geoMapDome",
//   name: "geoMapDome",
//   meta: {
//     title: "geoMapDome",
//   },
//   component: () => import('../views/tongji/geoMapDome.vue'),
// },
// {
//   path: "/echarts3Dworld",
//   name: "echarts3Dworld",
//   meta: {
//     title: "echarts3Dworld",
//   },
//   component: () => import('../views/tongji/echarts3Dworld.vue'),
// },
{
  path: "/tongji/jinchukou",
  name: "jinchukou",
  meta: {
    title: "统计数据-进出口数据",
    routerClass: "rc-type4",
    needLogin: true
  },
  component: () => import('../views/tongji/jinchukou.vue'),
},
{
  path: "/nav/industry",
  name: "nav_industry",
  meta: {
    title: "产业导航",
    routerClass: "rc-type3",
    needLogin: true
  },
  component: () => import('../views/nav/industry.vue'),
},
{
  path: "/nav/company",
  name: "nav_company",
  meta: {
    title: "企业导航",
    routerClass: "rc-type3",
    needLogin: true
  },
  component: () => import('../views/nav/company.vue'),
},
{
  path: "/nav/school",
  name: "nav_school",
  meta: {
    title: "高校导航",
    routerClass: "rc-type3",
    needLogin: true
  },
  component: () => import('../views/nav/school.vue'),
},
{
  path: "/nav/region",
  name: "nav_region",
  meta: {
    title: "区域导航",
    routerClass: "rc-type3",
    needLogin: true
  },
  component: () => import('../views/nav/region.vue'),
},
{
  path: "/tongji/hgnd",
  name: "tongji_hgnd",
  meta: {
    title: "全国宏观年度库",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/hgnd.vue'),
},
{
  path: "/tongji/hgyd",
  name: "tongji_hgyd",
  meta: {
    title: "全国宏观月度库",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/hgyd.vue'),
},
{
  path: "/tongji/fsnd",
  name: "tongji_fsnd",
  meta: {
    title: "分省宏观年度库",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/fsnd.vue'),
},
{
  path: "/tongji/fsyd",
  name: "tongji_fsyd",
  meta: {
    title: "分省宏观月度库",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/fsyd.vue'),
},
{
  path: "/tongji/spmy",
  name: "tongji_spmy",
  meta: {
    title: "商品贸易数据库",
    needLogin: true,
    routerClass: "rc-type4",
  },
  component: () => import('../views/tongji/spmy.vue'),
},
{
  path: "/console/editor",
  name: "compose_editor",
  meta: {
    title: "在线撰写",
    routerClass: "rc-compose",
    needLogin: true
  },
  component: () => import('../views/console_new/editor.vue'),
},
{
  path: "/console/index",
  name: "compose_index",
  meta: {
    title: "我的主页",
    routerClass: "rc-compose",
    needLogin: true,
  },
  component: () => import('../views/console_new/index.vue'),
},
{
  path: "/console/list",
  name: "compose_list",
  meta: {
    title: "我的创作",
    routerClass: "rc-compose",
    needLogin: true,
  },
  component: () => import('../views/console_new/list.vue'),
},
{
  path: "/console/history",
  name: "compose_history",
  meta: {
    title: "最近修改",
    routerClass: "rc-compose",
    needLogin: true,
  },
  component: () => import('../views/console_new/history.vue'),
},
{
  path: "/console/trash",
  name: "compose_trash",
  meta: {
    title: "回收站",
    routerClass: "rc-compose",
    needLogin: true,
  },
  component: () => import('../views/console_new/trash.vue'),
},
{
  path: "/console/read",
  name: "compose_read",
  meta: {
    title: "在线阅读",
    routerClass: "rc-compose",
    needLogin: true,
  },
  component: () => import('../views/console_new/read.vue'),
},

// {
//   path: encodeURI("/我的主页"),
//   name: "compose_index",
//   meta: {
//     title: "我的主页",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/我的主页.vue'),
// },
// {
//   path: encodeURI("/我的创作"),
//   name: "compose_index",
//   meta: {
//     title: "我的创作",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/我的创作.vue'),
// },
// {
//   path: encodeURI("/我的素材"),
//   name: "compose_index",
//   meta: {
//     title: "我的素材",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/我的素材.vue'),
// },
// {
//   path: encodeURI("/我的模板"),
//   name: "compose_index",
//   meta: {
//     title: "我的模板",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/我的模板.vue'),
// },
// {
//   path: encodeURI("/最近修改"),
//   name: "compose_index",
//   meta: {
//     title: "最近修改",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/最近修改.vue'),
// },
// {
//   path: encodeURI("/回收站"),
//   name: "compose_index",
//   meta: {
//     title: "回收站",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/回收站.vue'),
// },
// {
//   path: encodeURI("/在线撰写"),
//   name: "compose_index",
//   meta: {
//     title: "在线撰写",
//     routerClass: "rc-compose",
//   },
//   component: () => import('../html/在线撰写.vue'),
// },
];

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
}

export default router;
